/** Product mockup: the six Bollywood Class Ready volumes in a dance studio. Used in the hero and the pricing card. */
export const heroImage =
  'https://cdn.magicpatterns.com/uploads/ceDtd8D4avHTfWLeusKzdf/Use-the-first-reference-image-as-the-com.png'

export const productImage = heroImage
